module.exports = __webpack_public_path__ + "static/media/W18-1108_AW_Bourbon_Steakhouse_Desktop_Hero_2396x1473_en.39838f87.jpg";